__turbopack_context__.v({
  "details": "Details-module__w_1q9W__details",
  "detailsShort": "Details-module__w_1q9W__detailsShort",
  "details__caretIcon": "Details-module__w_1q9W__details__caretIcon",
  "details__completedIcon": "Details-module__w_1q9W__details__completedIcon",
  "details__completedIconIncomplete": "Details-module__w_1q9W__details__completedIconIncomplete",
  "isAlwaysClosed": "Details-module__w_1q9W__isAlwaysClosed",
});
